

// ============================= Time Constants ================================
class TimeConstants {
  static ONE_SECOND_MILLIS = 1000;
  static ONE_MINUTE_MILLIS = 60 * this.ONE_SECOND_MILLIS;

  static FIVE_MINUTE_MILLIS = 5 * this.ONE_MINUTE_MILLIS;
  static HALF_HOUR_MILLIS = 30 * this.ONE_MINUTE_MILLIS;
  static ONE_HOUR_MILLIS = 60 * this.ONE_MINUTE_MILLIS;

  static TWELVE_HOUR_MILLIS = 12 * this.ONE_HOUR_MILLIS;
  static ONE_DAY_MILLIS = 24 * this.ONE_HOUR_MILLIS;
}
// =============================================================================


export {
  TimeConstants
};
